import React, { forwardRef, useRef, useImperativeHandle, memo, useEffect } from "react";
import Icon from "../../components/icons";

const DashboardTableBodyRowMini = forwardRef((props, ref) => {
  const {
    item,
    indexRow,
    showCloseContent,
    setSelectedRowIndex,
    updateNetWorthData,
    currentUser,
    handleChangeUser,
    handleFavorite,
    getContentData,
    is_client,
    gridStyle
  } = props;

  const rowRef = useRef(null);
  const chevronRef = useRef(null);
  const starRef = useRef(null);

  useImperativeHandle(ref, () => {
    return {
      row: rowRef.current,
      chevron: chevronRef.current,
      star: starRef.current,
    };
  });

  return (
    <div
      key={`${indexRow}-row`}
      className={`c-table-dashboard__row is-six`}
      style={gridStyle}
      ref={rowRef}
    >
      {Object.entries(item).map(([key, value], index) => {
        // If it's not content we display a table cell
        if(key === "is_pro"){
          return null;
        }
        if (key !== "content" && key !== "id") {
          if (index === 0) {
            return (
              <div
                key={`${index}-body-item`}
                className="c-table-dashboard__cell is-first"
              >
                <div className="c-table-dashboard__cell-first-content">
                  <span
                    style={item.id !== null ? { cursor: "pointer" } : {}}
                    data-user
                    // onClick={(e) => item.id == currentUser.id ? window.location.href = '/' : handleChangeUser(e, item) }
                    onClick={(e) => item.id !== null ? handleChangeUser(e, item) : "" }
                  >
                    {/* {indexRow + 1} */}
                    {value}
                  </span>
                </div>
              </div>
            );
          } else if (value.url || value.url === "") {
            return (
              <div
                className="c-table-dashboard__cell"
                key={`${index}-body-item`}
              >
                {value.url !== "" && (
                  <a href={value.url} target="_blank">
                    <Icon name="Eye" />
                  </a>
                )}
              </div>
            );
          } else if (value === true) {
            return (
              <div
                className="c-table-dashboard__cell"
                key={`${index}-body-item`}
              >
                <a href={value.url} target="_blank" rel="noreferrer">
                  <Icon name="Check" />
                </a>
              </div>
            );
          } else if (value === false) {
            return (
              <div
                className="c-table-dashboard__cell"
                key={`${index}-body-item`}
              >
                <a href={value.url} target="_blank" rel="noreferrer">
                  <Icon name="Close" color="#f3b01c" />
                </a>
              </div>
            );
          } else if (value.value) {
            return (
              <div
                className="c-table-dashboard__cell"
                key={`${index}-body-item`}
              >
                <span style={{ flex: 1 }}>{value.value}</span>
              </div>
            );
          } else {
            return (
              <div
                className="c-table-dashboard__cell"
                key={`${index}-body-item`}
              >
                <span>{value}</span>
              </div>
            );
          }
        }
      })}
    </div>
  );
});

export default memo(DashboardTableBodyRowMini)
